import React from "react";
import './Footer.scss'
import { AppIcons } from "../../../data/appIcons"
import Image from "../../../components/image/Image";

const Footer = () =>
{
    return (
        <div className="footer-section">
            <div className="custom-width-foot">
                <div className="d-flex column-gap-4 align-items-end">
                    <div className="footer-logo-sec">
                        <Image
                            imagePath={ AppIcons.footerWhiteLogo }
                            imgCustomClassName="open-bar"
                            altText="Icon"
                        ></Image>
                    </div>
                    <div className="footer-link-and-copyright-sec">
                        {/* <div className="footer-copyright">
                            <span> © Singapore Green Building Council </span>{" "}
                        </div> */}
                        <div className="footer-copyright">
                            <span className="copyright-txt"> ©2026 Singapore Green Building Council </span>{ " " }
                            <span className="footer-uen-sec mr-2">
                                UEN:T09SS0112H
                            </span>
                        </div>
                        <div className="footer-list">
                            <div className="footer-terms-and-privacy-wrapper">
                                <span><a
                                    href="https://www.sgbc.sg/terms-conditions/"
                                    rel="noopener noreferrer"
                                >
                                     Terms &amp; Conditions of Use of Website
                                </a></span>
                                <span><span className="white-dot"></span></span>
                                <span> <a
                                    href="https://www.sgbc.sg/privacy-policy/"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy
                                </a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Footer;
